export enum COLORS {
  IMMERSIVE_BLUE_DARK = "#22404D",
  BOUNDLESS_BLUE = "#285F74",
  AQUA = "#00C0CA",
  LIGTH_BLUE = "#C3EDEF",
  TEAL_BLUE = "#008B9C",
  GRAY = "#EEF3F4",
  RED = "#B14646",
  HEART_RED = "#ef4444",
  EMPOWERED_YELLOW = "#E3E24F",
  BRONZE_BROWN = "#CE8946",
  SILVER = "#C8CFD2",
  FLAME_YELLOW = "#FFC800",
  GOLD_YELLOW = "#D38700",
  GRAY_LIGHT = "#F8F8F8",
  WHITE = "#FFFFFF",
  LIGHT_GRAY = "#B7B7B7",
  DARK_GRAY = "#959595",
}
